import PropTypes from 'prop-types';
import { memo } from 'react';
import { twMerge } from 'tailwind-merge';

import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import { isGenieUser } from 'lib/user';

const UserSpecialty = ({
  className,
  icon = true,
  size = 'size2',
  userId,
  userSpecialtyName = null,
}) => (
  <div className={twMerge('flex items-center', className)}>
    {icon && (
      <Icon
        className="mr-2"
        name={isGenieUser(userId) ? 'verified-color' : 'specialist'}
        size="size3"
      />
    )}
    <Text className="whitespace-pre-line" size={size}>
      Especialista em <b>{`${userSpecialtyName}`}</b>
    </Text>
  </div>
);

UserSpecialty.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  icon: PropTypes.object,
  size: PropTypes.string,
  userId: PropTypes.number.isRequired,
  userSpecialtyName: PropTypes.string,
};

export default memo(UserSpecialty);
